import { Routes } from '@angular/router';
import { ReportsComponent } from './reports/reports.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

export const routes: Routes = [
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
  },
  { path: '', redirectTo: '/reports', pathMatch: 'full' },
  { path: '**', component: PagenotfoundComponent, canActivate: [AuthGuard] },
];
